import { PERMISSION, ROLE_TYPE } from "@supplier/meta";
import { AccountType, useAccountStore } from "@/stores/account";
import { useUserStore } from "@/stores/user";

// 子账号包含进销存管理权限
export const hasPurchaseSalesInventory = (permissions: number[]) => {
    const userStore = useUserStore();
    const accountStore = useAccountStore();
    if ([AccountType.ROOT_ACCOUNT, AccountType.ASSOCIATED].includes(accountStore.accountType)) {
        return userStore.userInfo.customer?.roles.includes(ROLE_TYPE.PURCHASE_CUSTOMER.code);
    } else {
        return permissions?.some((permission: number) => {
            if (
                [
                    PERMISSION.CONTRACT,
                    PERMISSION.PAYMENT,
                    PERMISSION.FREIGHT,
                    PERMISSION.SHIPMENT,
                    PERMISSION.SIGNATURE,
                    PERMISSION.RECONCILIATION,
                    PERMISSION.INVOICE,
                    PERMISSION.FINANCING,
                    PERMISSION.INBOUND,
                    PERMISSION.OUTBOUND,
                    PERMISSION.SAMPLING,
                    PERMISSION.INVENTORY,
                    PERMISSION.PLEDGE,
                    PERMISSION.WAREHOUSE,
                    PERMISSION.STORAGE_INCEPTION,
                    PERMISSION.REPORT
                ].some(meta => meta.code === permission)
            ) {
                return userStore.userInfo.proxyAccount?.roles.includes(ROLE_TYPE.PURCHASE_CUSTOMER.code);
            }
            return false;
        });
    }
};

// 子账号包含仓储业务权限
export const hasWarehouseSupervision = (permissions: number[]) => {
    const userStore = useUserStore();
    const accountStore = useAccountStore();
    if ([AccountType.ROOT_ACCOUNT, AccountType.ASSOCIATED].includes(accountStore.accountType)) {
        return userStore.userInfo.customer?.roles.includes(ROLE_TYPE.WAREHOUSE_CUSTOMER.code);
    } else {
        return permissions?.some((permission: number) => {
            if (
                [
                    PERMISSION.STOCK_CONTRACT,
                    PERMISSION.STOCK_OUTBOUND,
                    PERMISSION.STOCK_INBOUND,
                    PERMISSION.TRANSFER,
                    PERMISSION.STOCK_SAMPLING,
                    PERMISSION.STOCK_INVENTORY
                ].some(meta => meta.code === permission)
            ) {
                return userStore.userInfo.proxyAccount?.roles.includes(ROLE_TYPE.WAREHOUSE_CUSTOMER.code);
            }
            return false;
        });
    }
};
// 子账号包含仓储管理权限
export const hasWarehouseManagementSupervision = (permissions: number[]) => {
    const userStore = useUserStore();
    const accountStore = useAccountStore();
    if ([AccountType.ROOT_ACCOUNT, AccountType.ASSOCIATED].includes(accountStore.accountType)) {
        return userStore.userInfo.customer?.roles.includes(ROLE_TYPE.WAREHOUSE_MANAGE_CUSTOMER.code);
    } else {
        return permissions?.some((permission: number) => {
            if (
                [PERMISSION.STORE_CONTRACT, PERMISSION.STORE_OUTBOUND, PERMISSION.STORE_INBOUND].some(
                    meta => meta.code === permission
                )
            ) {
                return userStore.userInfo.proxyAccount?.roles.includes(ROLE_TYPE.WAREHOUSE_MANAGE_CUSTOMER.code);
            }
            return false;
        });
    }
};

// 判断是否存在拥有某个操作权限
export const hasPermission = (permission: number) => {
    const accountStore = useAccountStore();
    const userStore = useUserStore();
    if (accountStore.accountType === AccountType.ROOT_ACCOUNT) {
        return true;
    } else {
        const permissions = userStore.userInfo.permissions || [];
        return permissions.includes(permission);
    }
};

// 子账号包含贸易业务权限
export const hasTradePermission = (permissions: number[]) => {
    const userStore = useUserStore();
    const accountStore = useAccountStore();
    if ([AccountType.ROOT_ACCOUNT, AccountType.ASSOCIATED].includes(accountStore.accountType)) {
        return userStore.userInfo.customer?.roles.includes(ROLE_TYPE.TRADE_CUSTOMER.code);
    } else {
        return permissions?.some((permission: number) => {
            if ([PERMISSION.TRADE_CONTRACT, PERMISSION.TRADE_RECONCILIATION].some(meta => meta.code === permission)) {
                return userStore.userInfo.proxyAccount?.roles.includes(ROLE_TYPE.TRADE_CUSTOMER.code);
            }
            return false;
        });
    }
};
